import type { LocalizedText, TermLanguage } from "../api/types";

/** Longer description of an entry from a data package, collapsed. Without a text nothing is shown; the label names the entry where several stand together. */
export function LongText({ value, language = "de", label = "Beschreibung" }: { value: LocalizedText | null | undefined; language?: TermLanguage; label?: string }) {
  if (!value) return null;
  const parts = language === "en" ? [value.en ?? value.de] : language === "both" && value.en && value.en !== value.de ? [value.de, value.en] : [value.de];
  return (
    <details className="long-text">
      <summary>{label}</summary>
      {parts.map((part, i) => (
        <div key={i} className="long-text-body" lang={part === value.en && part !== value.de ? "en" : "de"}>
          {part}
        </div>
      ))}
    </details>
  );
}
